/* eslint-disable react/destructuring-assignment */
import { Table as AntTable } from 'antd';
import useWindowSize from 'hooks/useWindowSize';
import React from 'react';

import MobileTable from './MobileTable';
import ResponsiveMobileTable from './ResponsiveMobileTable';
import { DataEntity, ITableProps, MobileTableType } from './types';

const Table = <T extends DataEntity>(props: ITableProps<T>) => {
  const { wrapperClassName, widthThreshold, mobileConfig, ...tableProps } = props;

  const { isMobile } = useWindowSize(widthThreshold);
  const { mobileDesignType } = props;
  const nullRender = props.nullRender || '--';

  return (
    <div className={`table-gradient-wrapper w-full ${wrapperClassName} ${props?.onRow ? 'clickable' : ''}`}>
      {!isMobile || !widthThreshold ? (
        <AntTable
          {...tableProps}
          pagination={props.pagination === false ? false : { showSizeChanger: false, ...tableProps.pagination }}
        />
      ) : (
        <>
          {mobileDesignType === MobileTableType.CARD && mobileConfig && (
            <MobileTable mobileConfig={mobileConfig} {...tableProps} />
          )}
          {mobileDesignType === MobileTableType.RESPONSIVE_TABLE && (
            <ResponsiveMobileTable {...tableProps} nullRender={nullRender} />
          )}
        </>
      )}
    </div>
  );
};

const defaultProps: Partial<ITableProps> = {
  mobileConfig: undefined,
  wrapperClassName: '',
  nullRender: '--',
  mobileDesignType: MobileTableType.CARD,
};

Table.defaultProps = defaultProps;

export default Table;
